import { Card, CardContent, Typography } from "@material-ui/core"
import noDataIconImage from "../../../../assets/images/no-data-icon.svg"

import React from "react"
import useStyles from "./styles"
import { withRouter } from "react-router"

const NoData = () => {
  const classes = useStyles()

  return (
    <Card className={classes.cardContainer}>
      <CardContent className={classes.imageContainer}>
        <img
          src={noDataIconImage}
          alt="no data logo"
          className={classes.noDataIcon}
        />
        <Typography variant="h3" className={classes.noDataText}>
          There are currently no positions or crew members for this shoot.
        </Typography>
      </CardContent>
    </Card>
  )
}

export default withRouter(NoData)
